/* tslint:disable */

// AUTO-GENERATED FILE. DO NOT EDIT.

export const CURRENT_REVISION = "f214b98ab531d3d0b730e1f9ddd8005e14139d8f";
